export default __webpack_public_path__ + "static/media/team-8.6f7ffde5.png";